import { Card, Tag, Typography, Image, Tooltip, Button } from 'antd';
import { EnvironmentOutlined, UserOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Text, Paragraph } = Typography;

const ServiceCard = ({ service, onEdit, onDelete }) => {
    const imgUrl = service.images && service.images.file_path
        ? process.env.REACT_APP_URL + service.images.file_path
        : null;

    return (
        <Card
            hoverable
            styles={{
                body: { padding: 0 },
            }}
            style={{
                borderRadius: 14,
                overflow: 'hidden',
                border: '1px solid var(--qk-border)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.25s, transform 0.25s',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(102,126,234,0.15)';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
        >
            {/* === Rasm === */}
            <div style={{ position: 'relative', height: 180, overflow: 'hidden', background: 'var(--qk-bg-soft)' }}>
                {imgUrl ? (
                    <Image
                        src={imgUrl}
                        alt={service.name}
                        width="100%"
                        height={180}
                        style={{ objectFit: 'cover', display: 'block' }}
                    />
                ) : (
                    <div style={{
                        height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#bbb', fontSize: 40,
                    }}>
                        <UserOutlined />
                    </div>
                )}
                {service.type && (
                    <Tag
                        color="purple"
                        style={{
                            position: 'absolute', top: 10, left: 10,
                            borderRadius: 8, fontWeight: 600, fontSize: 11,
                            padding: '2px 10px',
                            backdropFilter: 'blur(4px)',
                        }}
                    >
                        {service.type}
                    </Tag>
                )}
            </div>

            {/* === Content === */}
            <div style={{ padding: '14px 16px 10px' }}>
                <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 4 }}>
                    {service.name}
                </Text>

                <div style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#888', fontSize: 13, marginBottom: 8 }}>
                    <EnvironmentOutlined style={{ fontSize: 13 }} />
                    <Text type="secondary" style={{ fontSize: 13 }} ellipsis>
                        {service.region}{service.district ? `, ${service.district}` : ''}
                    </Text>
                </div>

                {service.address && (
                    <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 8 }}>
                        {service.address}
                    </Text>
                )}
            </div>

            {/* === Footer === */}
            <div style={{
                display: 'flex', justifyContent: 'flex-end', gap: 4,
                padding: '8px 12px',
                borderTop: '1px solid #f5f5f5',
                background: 'var(--qk-bg-soft)',
            }}>
                <Link to={"service/" + service.id}><Button type='primary' size='medium' block icon={<EyeOutlined />}>Batafsil</Button></Link>
                {/* {onEdit && (
                    <Tooltip title="Tahrirlash">
                        <button
                            type="button"
                            onClick={() => onEdit(service)}
                            style={{
                                width: 32, height: 32, borderRadius: 8,
                                border: '1px solid var(--qk-border)', background: 'var(--qk-card-bg)',
                                cursor: 'pointer', display: 'flex',
                                alignItems: 'center', justifyContent: 'center',
                                color: '#667eea', fontSize: 14,
                                transition: 'all 0.2s',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#667eea'; e.currentTarget.style.color = '#fff'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#667eea'; }}
                        >
                            <EditOutlined />
                        </button>
                    </Tooltip>
                )} */}
                {onDelete && (
                    <Tooltip title="O'chirish">
                        <button
                            type="button"
                            onClick={() => onDelete(service)}
                            style={{
                                width: 32, height: 32, borderRadius: 8,
                                border: '1px solid var(--qk-border)', background: 'var(--qk-card-bg)',
                                cursor: 'pointer', display: 'flex',
                                alignItems: 'center', justifyContent: 'center',
                                color: '#ff4d4f', fontSize: 14,
                                transition: 'all 0.2s',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#ff4d4f'; e.currentTarget.style.color = '#fff'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#ff4d4f'; }}
                        >
                            <DeleteOutlined />
                        </button>
                    </Tooltip>
                )}
            </div>
        </Card>
    );
};

export default ServiceCard;
